module.exports = __webpack_public_path__ + "img/staff_return.3fb300e8.png";